import React from "react";
const EyeClosed: React.FC<{ className: string; onClick: () => void }> = ({
  className,
  onClick,
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <path
        d="M7.0247 8.84388L7.02563 8.84314C8.37935 7.76401 10.2144 6.875 12.4984 6.875C14.7825 6.875 16.6175 7.76401 17.9712 8.84314L17.9722 8.84388C19.2982 9.89795 20.1865 11.1542 20.6095 12C20.1868 12.8451 19.2985 14.0994 17.9714 15.1567L17.9712 15.1569C16.6175 16.236 14.7825 17.125 12.4984 17.125C10.2144 17.125 8.37935 16.236 7.02563 15.1569L7.0247 15.1561C5.69746 14.101 4.80944 12.8441 4.39029 12C4.80944 11.156 5.69746 9.89896 7.0247 8.84388Z"
        stroke="#7F9595"
        strokeWidth="1.75"
      />
      <circle cx="12.5" cy="12" r="3" fill="#7F9595" />
      <line
        x1="5.85355"
        y1="5.64645"
        x2="18.5815"
        y2="18.3744"
        stroke="white"
      />
      <line
        x1="6.82575"
        y1="4.67425"
        x2="19.5537"
        y2="17.4022"
        stroke="#7F9595"
        strokeWidth="1.75"
      />
    </svg>
  );
};

export default EyeClosed;
